import { useMemo } from 'react'
import { IProfile } from '@/types/profile'
import { Team } from '@/types/auth'
import { getFavoriteTeam } from '@/utils/teams'
import settings from '@/settings/public'

const appCode = settings.app.code ?? ''

/**
 * The user's favorite team as served by the profile. The profile service
 * writes a Sport-verified snapshot and refreshes name/shortName/flag/colors
 * on every read, so the profile entry IS the enriched team — no catalog
 * fetch, no client-side merge (PRO-467/468).
 */
export function useEnrichedFavoriteTeam(profile: IProfile | undefined): Team | null {
  return useMemo(() => getFavoriteTeam(profile, appCode), [profile])
}
